'use client';

import { Heading } from '@depop/web-thrift-ui/Typography';
import { ArrowDownIcon } from '@depop/web-ui-kit/Icons/ArrowDownIcon';
import { Panel } from '@depop/web-ui-kit/Panel';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { Placeholder, PlaceHolderShape } from '@/components/Placeholder';

export function GuestCheckoutSummarySkeleton() {
  const t = useTranslations('checkout');

  return (
    <>
      <div className={styles.accordionWrapper}>
        <Panel
          className={styles.accordionPanel}
          id="checkout-summary-accordion-skeleton"
        >
          <div className={styles.skeletonAccordionRow}>
            <div className={styles.skeletonAccordionTitle}>
              <Heading variant="md">{t('OrderSummaryTitle')}</Heading>
              <ArrowDownIcon size={24} />
            </div>
            <Placeholder
              shape={PlaceHolderShape.PILL}
              width="64px"
              height="20px"
            />
          </div>
        </Panel>
      </div>

      <div className={styles.orderSummaryPanel}>
        <Panel
          className={styles.panel}
          id="checkout-summary-panel-skeleton"
          as="aside"
        >
          <Heading variant="md" className={styles.title}>
            {t('OrderSummaryTitle')}
          </Heading>
          <div className={styles.skeletonPanelContent}>
            <div className={styles.skeletonSellerRow}>
              <Placeholder
                shape={PlaceHolderShape.CIRCLE}
                width="32px"
                height="32px"
              />
              <Placeholder
                shape={PlaceHolderShape.PILL}
                width="40%"
                height="16px"
              />
            </div>
            <Placeholder
              shape={PlaceHolderShape.RECTANGLE}
              width="100%"
              height="80px"
            />
            <Placeholder
              shape={PlaceHolderShape.RECTANGLE}
              width="100%"
              height="16px"
            />
            <Placeholder
              shape={PlaceHolderShape.RECTANGLE}
              width="60%"
              height="16px"
            />
          </div>
        </Panel>
      </div>
    </>
  );
}
